export const EXTRA_STATUS = {
  CANCELLED: 6,
  LOAN_REPAID: 13,
  SETTLED: 1,
  VARIED: 63,
};
